import { render } from "./Content.vue?vue&type=template&id=19787fd0"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import "./Content.vue?vue&type=style&index=0&id=19787fd0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Layout/Content.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19787fd0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19787fd0', __exports__)) {
    api.reload('19787fd0', __exports__)
  }
  
  module.hot.accept("./Content.vue?vue&type=template&id=19787fd0", () => {
    api.rerender('19787fd0', render)
  })

}


export default __exports__